<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("task module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive for uploads')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
      <div class="column"></div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_notify_assigned"
            name="chk_notify_assigned"
            v-model="meta.notify_assigned"
          />
          <label for="chk_notify_assigned">{{
            $t("notify on user assigned")
          }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('on user assigned notification template')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="user_assigned_template_changed"
            ref="user_assigned_template_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_notify_finished"
            name="chk_notify_finished"
            v-model="meta.notify_finished"
          />
          <label for="chk_notify_finished">{{
            $t("notify on task finished")
          }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('on task finished notification template')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="task_finished_template_changed"
            ref="task_finished_template_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "TaskSettings",
  components: {
    GenericDropdown,
    GenericUploader,
  },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    drive_changed(value) {
      this.meta.drive_id = value.drive_id;
    },
    user_assigned_template_changed(value) {
      if (value) this.meta.user_assigned_template_id = value.template_id;
    },
    task_finished_template_changed(value) {
      if (value) this.meta.task_finished_template_id = value.template_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.drive_id) v.$refs.drive_dropdown.set_value(conf.drive_id);

          if (conf.user_assigned_template_id)
            v.$refs.user_assigned_template_dropdown.set_value(
              conf.user_assigned_template_id
            );

          if (conf.task_finished_template_id)
            v.$refs.task_finished_template_dropdown.set_value(
              conf.task_finished_template_id
            );
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
